module.exports = __webpack_public_path__ + "img/cinema-illustration.e592c1d8.jpg";